<div class="dhl-field-autocomplete-v2" [formGroup]="frmGroup" [hidden]="this.frmGroup.get(this.configData.name)['hidden']" (click)="!this.configData?.events ? onCommonEventHander('CLICK', $event) : ''">
    <div class="form-field-wrapper" [ngClass]="{'typing':typing ,'disabled': frmGroup.get(this.configData.name)['disabled']}">
        <div class="form-field-control" #formControl
            [ngClass]="{'error': (frmGroup.get(configData.name).errors && frmGroup.get(configData.name).touched && !frmGroup.get(configData.name).valid),'active' : searchStr}">
            <input appFormFieldAutocompleteV2 #inputEle type="{{fieldType}}" class="base-field" autocomplete="off"
                [attr.data-placeholder]="placeholder | translate" [required]="configData.required"
                [formControlName]="$safeNavigationMigration(configData?.name)" [formControl]="frmGroup.get(configData.name)"
                [(ngModel)]="searchStr" (keyup)="onkeyupHandler($event)" (click)="setOnFocus($event)"
                (change)="controlValueChange($event)" [ngClass]="{'base-field-height': (configData['customHeight'] || configData['customHeight'] === 'true'), 'base-field-height-readonly': configData['readonly'], 'pointer': configData['cursor'] === true}"/>
            <span class="form-field-label">
                <label class="base-label">
                    {{$safeNavigationMigration(configData?.label) | translate}}
                    <span *ngIf="configData?.required"> *</span>
                </label>
            </span>
            <span *ngIf="fieldIcon" class="field-icon" (click)="popFieldAction($event)">
                <span class="default-icon">
                    <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,662,20,20))"
                        style="width:20px;height:20px" type="image/svg+xml" />
                </span>
                <span class="active-icon">
                    <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,692,20,20))"
                        style="width:20px;height:20px" type="image/svg+xml" />
                </span>
            </span>
        </div>
        <div [hidden]="(typing && dataAvailable)" class="form-field-hint" *ngIf="frmGroup.get(configData.name)['secondaryText'] && !noItemFound">
            <a style="text-decoration: none; cursor: pointer; color: #d40511; font-size: 14px" [href]="mapUrl" target="blank" matTooltip="Show in map">
                <span *ngIf="configData['secondaryText'];">
                    <span>
                        {{ frmGroup.get(this.configData.name)['secondaryText'] | removeText : 'undefined' | removeText : 'null' | removeText : ',,,' | removeText : ',,'}}
                    </span>
                </span>
            </a>
        </div>
        <div [hidden]="(typing && dataAvailable)" class="form-field-error"
            [ngClass]="{'hide-error': !(frmGroup.get(configData.name).errors && (frmGroup.get(configData.name).touched ||frmGroup.get(configData.name).value) && !frmGroup.get(configData.name).valid)}">
            <span class="error-icon">
                <img class="dhl-input-error-icon"
                    src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
            </span>
            <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
                <span *ngIf="frmGroup.get(configData.name).errors.required">{{enum.Required_Validation | translate}}</span>
                <span *ngIf="frmGroup.get(configData.name).errors.NoItemFound">{{enum.NoRecordFound_Validation | translate}}</span>
                <span *ngIf="frmGroup.get(configData.name).errors.selectFromList">{{enum.SelectFromList_Validation | translate}}</span>
                <span *ngIf="frmGroup.get(configData.name).errors.locationInactive">{{locationInactiveError | translate}}</span>
                <span *ngIf="frmGroup.get(configData.name).errors?.groupValidationError">
                    {{$safeNavigationMigration(frmGroup.get(configData.name).errors?.groupValidationError) | translate}}
                </span>
            </span>
        </div>
        <div *ngIf="progressBar" class="search-result spinner"> 
            <app-progress-spinner-v2 ></app-progress-spinner-v2>
        </div>
        <div *ngIf="!progressBar && !locationList.length && addNewLocation" class="search-result">
            <div class="suggestion-list">
                <div (click)="AddNewLocation($event)">
                    <a class="list-items" >
                        <span class="suggestion-item" style="display: inline;flex-direction: column;">
                            <span>
                                Add New Location
                            </span>
                        </span>
                    </a>
                </div>
               
            </div>
        </div>

        <div [hidden]="!(typing && dataAvailable)" class="search-result">
            <div *ngIf="this.typing" class="search-history-wrapper">
                <label class="search-history-label">{{enum.Filter_Popup_Validation_Search_History | translate}}</label>
            </div>
            <div class="suggestion-list"  *ngFor="let item of locationList">
                <img style="height: 20px; width: 20px;"
                    src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,630,24,24))" />
                <a class="list-items" (click)="selectItem($event,item)">
                    <ng-container *ngIf="configData['primaryText'];">
                        <span class="suggestion-item"  style="display: inline;flex-direction: column;">
                            <span>
                                  {{ getPrimaryText(item) }}
                            </span>
                            <span *ngIf="configData['secondaryText'];">
                                <span class="secondary-label"
                                    *ngFor="let text of configData['secondaryText']; let rowIndex = index">
                                    {{item[text]}}
                                    <span *ngIf="rowIndex === (configData['secondaryText'].length/2)-1; else addComma">
                                        ->
                                    </span>
                                    <ng-template #addComma>
                                        <span *ngIf="rowIndex !== configData['secondaryText'].length-1">, </span>
                                    </ng-template>
                                </span>
                            </span>
                        </span>
                    </ng-container>
                </a>
            </div>
        </div>
    </div>
</div>